module.exports = __webpack_public_path__ + "img/picture_31.39119db2.png";